interface HighlightedTextProps {
  /** The text to display */
  text: string
  /** The substring to highlight (case-insensitive) */
  highlight: string
  /** CSS class for the highlighted portion (default: yellow background) */
  highlightClassName?: string
}

/**
 * Highlights matching substrings within text.
 * Used for search result highlighting in tables and lists.
 *
 * @example
 * <HighlightedText text="Hello World" highlight="world" />
 * // Renders: Hello <mark>World</mark>
 */
export function HighlightedText({
  text,
  highlight,
  highlightClassName = 'bg-yellow-200 text-inherit',
}: HighlightedTextProps) {
  if (!highlight.trim()) {
    return <>{text}</>
  }

  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi')
  const parts = text.split(regex)
  const lowerHighlight = highlight.toLowerCase()

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === lowerHighlight ? (
          <mark key={index} className={highlightClassName}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  )
}

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
